import React, { Fragment } from 'react';
import {
  FaRegEnvelope,
  FaInstagram,
  FaGlobe,
  FaTwitter,
  FaTiktok,
  FaLinkedin,
} from 'react-icons/fa';
import {
  getFileName, isValid, isText, decodeTags,
} from '../../../../utils';
import { AUTHOR_IMAGE_PLACEHOLDER } from '../../../../consts';
import '../../../Article/AuthorBios/authorBiosStyle.scss';
import '../../commerce.scss';
import '../../AboutUs/about-us.scss';
import '../../../Article/article-styles-pw.scss';
import Carousel from 'nuka-carousel';

class CarouselArrow extends React.Component {
  render() {
    const { direction, previousSlide, nextSlide, currentSlide, slidesToShow, slideCount } = this.props;

    const isInactive = (direction === 'prev' && currentSlide === 0) || (direction === 'next' && (slideCount - slidesToShow <= currentSlide) );
    const carouselArrowClassName = `carousel-arrow carousel-arrow-${direction} ${isInactive ? "inactive" : ""}`;

    return (
      <div className={carouselArrowClassName} onClick={() => !isInactive && (direction === 'prev' ? previousSlide() : nextSlide())}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    );
  }
}

const EditorsAndExperts = ({
  data,
  isMobile,
  isPage,
  hedUrl,
  articleLayout,
  isVertical
}) => {
  if (!isValid(data) || data.length === 0) {
    return null;
  }

  const { SITE_HOST } = process.env;
  const { bios } = data;
  const validBios = bios.filter(bio => isValid(bio.name));
  const bioClass = validBios.length <= 3 || isVertical ? 'large' : 'small';
  let wrapperClass = 'member-content-wrapper';
  const useCarousel = isVertical && !isMobile;
  const carouselProps = {
    dragging: false,
    swipping: false,
    slidesToScroll: 3,
    slidesToShow: 3,
    heightMode: 'max',
    previousDisabled: true,
    renderBottomCenterControls: false,
    wrapAround: false,
  };

  if (isValid(hedUrl)) {
    if (hedUrl === 'commerce-policy') {
      wrapperClass += ' commerce';
    } else if (hedUrl === 'about-us') {
      wrapperClass += ' about-us';
    }
  }

  if (isValid(articleLayout) && articleLayout === 'Content Hub') {
    wrapperClass += ' content-hub';
  }

  wrapperClass += ` ${bioClass}`;
  

  const renderedMembers = bios.map((member) => {
    const { name, slug, imageSrcMobile, imageSrcDesktop, title, seo, bio } = member;
    const className = `bio ${bioClass} ${bioClass === 'small' ? 'col-3 col-2-sm' : bioClass === 'large' ? 'col-4 col-4-sm' : ''}`;
    const memberImg = isValid(imageSrcDesktop) ? imageSrcDesktop : AUTHOR_IMAGE_PLACEHOLDER;
    const memberSlug = isValid(slug) ? slug : null;
    const memberTitle = isValid(title) ? title : 'Title Placeholder';
    const memberName = isValid(name) && bioClass === 'large' ? name.replace(/\s(?=[^ ]*$)/, "<br/>") : name;
    const memberDescription = isValid(seo) && isValid(seo.metaDescription) && seo.metaDescription != "" ? seo.metaDescription : null;
    const encodedDescription = decodeTags(memberDescription);

    return (
        <>
          {(memberName !== null) &&
          <>
          { memberSlug ?
          <a href={`/author/${memberSlug}`} target="_blank">
            <div className={`member-content ${bioClass === 'large' ? 'col-4 col-4-sm' : 'col-3 col-2-sm'}`}>
              <div className={className}>
                <div className={`member-img-container ${bioClass === 'large' ? 'col-2' : ''} col-2-sm`}>
                  <img className="member-img" src={memberImg} alt={getFileName(memberImg)} />
                </div>
                <div className='member-card col-2 col-2-sm'>
                  <h2 className='member-name' dangerouslySetInnerHTML={{ __html: memberName }}></h2>
                  <h3 className='member-title'>{memberTitle}</h3>
                  {(isValid(memberDescription) && bioClass === 'large') &&
                    <Fragment>
                    <div className='member-divider'/>
                    <div className='member-bio' dangerouslySetInnerHTML={{ __html: encodedDescription }}></div>
                    </Fragment>
                  }
                </div>
              </div>
            </div>
          </a>
          :
          <div className={`member-content ${bioClass === 'large' ? 'col-4 col-4-sm' : 'col-3 col-2-sm'}`}>
            <div className={className}>
              <div className={`member-img-container ${bioClass === 'large' ? 'col-2' : ''} col-2-sm`}>
                <img className="member-img" src={memberImg} alt={getFileName(memberImg)} />
              </div>
              <div className='member-card col-2 col-2-sm'>
                <h2 className='member-name' dangerouslySetInnerHTML={{ __html: memberName }}></h2>
                <h3 className='member-title'>{memberTitle}</h3>
                {(isValid(memberDescription) && bioClass === 'large') &&
                  <Fragment>
                  <div className='member-divider'/>
                  <div className='member-bio' dangerouslySetInnerHTML={{ __html: encodedDescription }}></div>
                  </Fragment>
                }
              </div>
            </div>
          </div>
          }
          </>
        }
        </>
    );
  });

  return (
    <>
      <div className={wrapperClass}>
      { useCarousel ? (
        <Carousel
          className="editors-carousel"
          {...carouselProps}
          renderCenterLeftControls={props => (<CarouselArrow direction="prev" {...props} />)}
          renderCenterRightControls={props => (<CarouselArrow direction="next" {...props} />)}>
          {renderedMembers}
        </Carousel>
      ): (
        <Fragment>
          {renderedMembers}
        </Fragment>
      )}
      </div>
    </>
  );
};

export default EditorsAndExperts;
